import { put, call, select, takeLatest } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import ActionTypes from '../constants/ActionTypes';
import {
  retakeTestApi,
  getReportSolutionSetByTestSlug,
  getReportSolutionBySolutionSlug,
} from '../api/test';
import { progressStart, progressStop } from '../actions';
import {
  showErrorToast,
  showInfoToast,
  showSuccessToast,
} from '../actions/toast';
import { getApiErrorData } from '../utils/helperFunction';
import {
  getAllSolutionRevisions,
  updateTestExpiryAndSessionState,
} from '../actions/test';
import { SESSION_STATE } from '../constants/AssessmentConstants';

function* getReportSolutionSet(args) {
  try {
    yield put(progressStart());
    const auth = yield select(state => state.auth.initUserDetails);

    const resp = yield call(
      getReportSolutionSetByTestSlug,
      args.testSlug,
      auth.username
    );
    yield put({
      type: `${ActionTypes.GET_REPORT_SOLUTIONSET}_SUCCESS`,
      payload: resp.data,
    });
  } catch (e) {
    const { toast } = yield select(state => state.appStatus);
    const errorInfo = getApiErrorData(e, 'TSS');
    if (errorInfo && errorInfo.message && !toast?.apiErrorInfo) {
      yield put(showErrorToast(errorInfo.message, errorInfo.apiErrorInfo));
    }
  } finally {
    yield put(progressStop());
  }
}

function* retakeTest(args) {
  const { slug } = yield select(state => state.test);
  try {
    yield put(progressStart());
    const { data } = yield call(retakeTestApi, args.testId);
    showSuccessToast('Test reset successful');
    if (data?.access_url) {
      window.location.href = data?.access_url;
    } else {
      window.location.href = `/test/${slug}`;
    }
  } catch (e) {
    const { toast } = yield select(state => state.appStatus);
    const errorInfo = getApiErrorData(e, 'RTT');
    if (errorInfo?.status === 409) {
      showInfoToast('Test is already reset, resuming test');
      window.location.href = `/test/${slug}`;
    } else if (errorInfo && errorInfo.message && !toast?.apiErrorInfo) {
      yield put(showErrorToast(errorInfo.message, errorInfo.apiErrorInfo));
    }
  } finally {
    yield put(progressStop());
  }
}

function* getReportSolution(args) {
  try {
    const { testSlug } = yield select(state => ({
      slug: state.test.slug,
    }));

    yield put(progressStart());
    const resp = yield call(
      getReportSolutionBySolutionSlug,
      args.solutionSlug,
      args.source,
      testSlug
    );
    yield put({
      type: `${ActionTypes.GET_REPORT_SOLUTION}_SUCCESS`,
      payload: resp.data,
    });
    const problemType = resp.data.solution_type;
    const problemSlug = resp.data.problem.slug;
    if (problemType === 'FBE') {
      yield put(getAllSolutionRevisions(problemSlug, args.solutionSlug));
    }
  } catch (e) {
    const { toast, slug } = yield select(state => ({
      toast: state.appStatus.toast,
      slug: state.test.slug,
    }));
    const errorInfo = getApiErrorData(e, 'GSS');
    if (errorInfo && errorInfo.message && !toast?.apiErrorInfo) {
      yield put(showErrorToast(errorInfo.message, errorInfo.apiErrorInfo));
    }
    if (e.response?.data?.action?.redirection) {
      yield put(
        updateTestExpiryAndSessionState({
          is_expired: true,
          session_state: SESSION_STATE.END,
        })
      );
      yield put(replace(`/test/${slug}/feedback`));
    }
  } finally {
    yield put(progressStop());
  }
}

export default function* loadAuthSaga() {
  yield takeLatest(ActionTypes.GET_REPORT_SOLUTIONSET, getReportSolutionSet);
  yield takeLatest(ActionTypes.RETAKE_TEST, retakeTest);
  yield takeLatest(ActionTypes.GET_REPORT_SOLUTION, getReportSolution);
}
